import React from 'react';
import { Droppable, Draggable } from '@hello-pangea/dnd';
import TaskCard from './TaskCard';
import { Task } from './App';

interface TaskListProps {
    droppableId: string;
    title: string;
    tasks: (Task & { id: number })[];  // tasks must have a non-null id
    onEditTask?: (task: Task) => void;
}

const TaskList: React.FC<TaskListProps> = ({ droppableId, title, tasks, onEditTask }) => {
    return (
        <div className="task-list">
            <h2>{title}</h2>
            <Droppable droppableId={droppableId}>
                {(provided) => (
                    <div
                        className="droppable-area"
                        {...provided.droppableProps}
                        ref={provided.innerRef}
                    >
                        {tasks.map((task, index) => (
                            <Draggable key={task.id} draggableId={String(task.id)} index={index}>
                                {(provided) => (
                                    <div
                                        ref={provided.innerRef}
                                        {...provided.draggableProps}
                                    >
                                        <TaskCard
                                            task={task}
                                            dragHandleProps={provided.dragHandleProps}
                                            onEdit={onEditTask}
                                        />
                                    </div>
                                )}
                            </Draggable>
                        ))}
                        {provided.placeholder}
                    </div>
                )}
            </Droppable>
        </div>
    );
};

export default TaskList;